import { render, staticRenderFns } from "./indexDetail.vue?vue&type=template&id=ba392c20&scoped=true&"
import script from "./indexDetail.vue?vue&type=script&lang=js&"
export * from "./indexDetail.vue?vue&type=script&lang=js&"
import style0 from "./indexDetail.vue?vue&type=style&index=0&id=ba392c20&prod&lang=scss&"
import style1 from "./indexDetail.vue?vue&type=style&index=1&id=ba392c20&prod&lang=scss&scoped=true&"
import style2 from "./indexDetail.vue?vue&type=style&index=2&id=ba392c20&prod&scoped=true&lang=css&"
import style3 from "./indexDetail.vue?vue&type=style&index=3&id=ba392c20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba392c20",
  null
  
)

export default component.exports